import { useState, useRef, useEffect } from "react";
import {
  Fab,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Typography,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Chat, Close, WhatsApp, Telegram } from "@mui/icons-material";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../api_Routes";
import { useNavigate } from "react-router-dom";

const FloatingChatButton = () => {
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const [mainMenuOpen, setMainMenuOpen] = useState(false);
  const [resellers, setResellers] = useState([]);


  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const { response } = await Helper.Get({
          url: `${api_Routes.Header.getResellers}`,
          hasToken: true,
        });
        if (response) {
          setResellers(response.data);
        }
      } catch (error) {
        console.error("Error fetching contacts:", error);
      }
    };

    fetchContacts();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        closeAllMenus();
      }
    };

    if (mainMenuOpen) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => document.removeEventListener("click", handleClickOutside);
  }, [mainMenuOpen]);

  const closeAllMenus = () => {
    setMainMenuOpen(false);
  };

  const handleMainMenuToggle = (event) => {
    event.stopPropagation();
    setMainMenuOpen((prev) => !prev);
  };

  const handleResellerClick = (reseller) => {
    closeAllMenus();
    navigate(`/chats/individual/admin/${reseller.admin_id}`);
  };

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 9999,
      }}
    >
      {/* Main FAB Button */}
      <Fab
        color="primary"
        onClick={handleMainMenuToggle}
        sx={{
          transition: "transform 0.3s",
          transform: mainMenuOpen ? "rotate(135deg)" : "rotate(0deg)",
        }}
      >
        {mainMenuOpen ? <Close /> : <Chat />}
      </Fab>

      {/* Resellers Menu */}
      {mainMenuOpen && (
        <Paper
          sx={{
            position: "absolute",
            bottom: 60,
            right: 0,
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            p: 1,
            boxShadow: 3,
            borderRadius: 2,
            minWidth: 200,
            maxWidth: 300,
            maxHeight: 500,
            overflow: "scroll",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              px: 2,
              py: 1,
              fontWeight: "bold",
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            Contact Reseller
          </Typography>

          {resellers.map((reseller, index) => (
            <MenuItem
              key={index}
              onClick={() => handleResellerClick(reseller)}
              sx={{
                borderRadius: 1,
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
                py: 1.5,
                whiteSpace: "nowrap",
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <img src={reseller.photo} alt={reseller.name}
                     style={{
                       border: "1px solid #296D99",
                       borderRadius: "50%",
                       cursor: "pointer",
                       width: "40px",
                       height: "40px",
                       marginRight:"5px"
                     }}/>
              </ListItemIcon>
              <ListItemText
                primary={reseller.name}
                primaryTypographyProps={{
                  fontWeight: 500,
                  fontSize: "0.875rem",
                  color: "text.primary",
                }}
              />
            </MenuItem>
          ))}
        </Paper>
      )}
    </div>
  );
};

export default FloatingChatButton;
